appHost.actions.register({
    // #region Vars
    name: '288a.ecommerce.carts.lines.add',
    // #endregion
    // #region Entry
    async execute(data, params) {
        // #region Data
        let tCart = data.cart;
        let tLine = data.cartLine;
        // #endregion
        // #region Check
        if (!tLine.itemNumber) {
            return this.Cancel();
        }
        if (tLine.quantity <= 0) {
            return this.Cancel();
        }
        // #endregion
        // #region Send
        try {
            // #region Documents
            if (data.rules) {
                if (!tLine.rules) {
                    tLine.rules = [];
                }
                data.rules.forEach((f) => {
                    tLine.rules.push(f);
                });
            }
            // #endregion
            // #region Update Line
            tCart.lines = [tLine];
            // #endregion
            // #region Logging
            utils.logDebug('288a.ecommerce.carts.lines.add', { cart: tCart });
            // #endregion
            // #region Send
            //Upload
            let tResult = await appHost.api.post('commerce/carts?mode=ifnotexists', tCart);
            //Set
            if (tResult?.data) {
                this.$store.commit('carts/setCart', tResult.data);
            }
            //Reset
            //await this.reset();
            //Notify
            appHost.notification.showToast(this.$appHost.localizer.t('client.Commerce.Products.' + (tCart.cartType === 'A' ? 'AddedToRequest' : 'AddedToCart')));
            // #endregion
        }
        catch (e) {
            appHost.notification.showError(e);
        }
        // #endregion
        return this.Ok();
    },
    // #endregion
});
export {};
